import React from "react";

const Button = ({name}) => {
    return(
        <button className="button">{name}</button>
    );
}

export default Button;